let translationExports = {}

if (typeof __webpack_require__ === 'function') {
  const requireContext = require.context('./', false, /.*\.json$/)

  translationExports = requireContext.keys()
    .map(file =>
      [file.replace(/(^.\/)|(\.json$)/g, ''), requireContext(file)])
    .reduce((translationFile, [name, file]) => {
      translationFile[name] = file
      return translationFile
    }, {})
} else {
  const normalizedPath = require('path').join(__dirname, './')

  require('fs').readdirSync(normalizedPath).forEach(function(file) {
    if (file.endsWith('json')) {
      translationExports[file.replace('.json', '')] = require('./' + file)
    }
  })
}

module.exports = translationExports
